module.exports = __webpack_public_path__ + "./resources/img/chrome.png";


//////////////////
// WEBPACK FOOTER
// ./resources/img/chrome.png
// module id = 80
// module chunks = 0